export const rolesRoutes = {
  "FMPS-ADMIN": [
    "/admin",
    "/accounting",
    "/payments",
    "/invoices",
    "/products",
    "/sales",
    "/orders",
    "/customers",
    "/travel-card-holders",
    "/tellers",
    "/tills",
    "/fleet",
    "/rosters",
    "/reports",
  ],
  "FMPS-ACCOUNT-MGR": [
    "/manager",
    "/ops-supervisor",
    "/accounting",
    "/products",
    "/customers",
    "/travel-card-holders",
    "/rosters",
    "/reports",
    "/payments",
    "/invoices",
    "/sales",
    "/tellers",
    "/tills",
  ],
  "FMPS-TELLER": [
    "/teller/till",
    "/payments",
    "/travel-card-holders",
  ],
  "FMPS-PAYMENT-CLERK": [
    "/sales-rep",
    "/payments",
    "/invoices",
    "/rosters/buses",
  ],
  "FMPS-AGENT": [
    "/main-agent",
  ],
  "FMPS-GOV": [
    "/slpta",
    "/rosters/buses",
  ],
  "FMPS-OPS-OFFICER": [
    "/operations",
    "/fleet",
    "/rosters",
  ],
  "FMPS-OPS-SUPERVISOR": [
    "/ops-supervisor",
    "/customers",
    "/travel-card-holders",
    "/rosters",
    "/reports",
  ],
  "FMPS-TRANSPORTER": [
    "/mtc",
    "/fleet",
    "/rosters/buses",
  ],
  "FMPS-DEMO": [
    "/manager",
    "/ops-supervisor",
    "/accounting",
    "/products",
    "/customers",
    "/travel-card-holders",
    "/rosters",
    "/reports",
    "/payments",
    "/invoices",
    "/sales",
    "/tellers",
    "/tills",
  ],
};
